<template>
	<div>
		<calendarevents></calendarevents>
	</div>
</template>

<script>
import calendarevents from '@/components/CalendarEvents'

export default {
	components: {
		calendarevents
	},
	data() {
		return {
		}
	}
};
</script>